export default __webpack_public_path__ + "static/media/Raider's Belt of the Covert Trail.65b915d7.jpg";